import './lib/jquery'

// document.addEventListener('DOMContentLoaded', () => {
$('[data-confirm]').click((e) => {
  const msg = e.target.dataset.confirm
  // eslint-disable-next-line no-restricted-globals
  if (msg !== null && msg !== '' && !confirm(msg)) {
    e.preventDefault()
  }
})
// })
